module.exports = __webpack_public_path__ + "static/media/settings_room_device_speed.2acbd923.svg";